import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertYouTubeIdToImg } from 'appSrc/utils';
import style from './styles/style.module.css';


class YouTubeCoverImage extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            mounted: false,
            videoImageA: convertYouTubeIdToImg( ( this.props.videoId || '' ), 'webp' ),
            videoImageB: convertYouTubeIdToImg( ( this.props.videoId || '' ), 'jpg' ),
        };
        this.regressionCount = 0;
    }
    componentDidMount() {
        this.setState( { mounted: true } );
    }
    checkCoverImage = ( e ) => {
        if( ( this.regressionCount < 2 ) && e.target.naturalHeight <= 90 ) {
            ++this.regressionCount;
            switch ( this.regressionCount ) {
                case 1:
                    this.setState( {
                        videoImageA: convertYouTubeIdToImg( this.props.videoId, 'med/webp' ),
                        videoImageB: convertYouTubeIdToImg( this.props.videoId, 'med/jpg' ),
                    } );
                    break;
                case 2:
                    this.setState( {
                        videoImageA: convertYouTubeIdToImg( this.props.videoId, 'small/webp' ),
                        videoImageB: convertYouTubeIdToImg( this.props.videoId, 'small/jpg' ),
                    } );
                    break;
                default:
                    this.regressionCount = 3;
                    break;
            }
        }
    }
    render() {
        const { coverImage, videoId } = this.props;
        const { videoImageB } = this.state;
        const usingVideo = !!videoId;

        return (
            <div className={ `${ style.listCoverImage } ${ this.props.className }`.trim() } style={ this.props.style } >
                <div className={ style.coverImage }>
                    <img className={ style.primaryImage }
                    onLoad={ usingVideo ? this.checkCoverImage : () => {} }
                    src={ usingVideo ? videoImageB : coverImage }
                    alt="cover image" />
                </div>
            </div>
        );
    }
}
YouTubeCoverImage.propTypes = {
    videoId: PropTypes.string,
    coverImage: PropTypes.string,
};
YouTubeCoverImage.defaultProps = {
    className: '',
};

export default connect()( YouTubeCoverImage );
